import React, {
  cloneElement,
  FC,
  isValidElement,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react'

import * as S from './Frame.styles'
import { FrameButtonProps } from './Frame.types'

function mapDeep(children: ReactNode, callback: (child: ReactElement) => ReactNode): ReactNode {
  return React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child
    }

    if (child.props.children) {
      child = cloneElement(child as ReactElement, {
        children: mapDeep(child.props.children, callback),
      })
    }

    return callback(child)
  })
}

export const Frame: FC<PropsWithChildren> = ({ children }) => {
  const childrenWithProps = mapDeep(children, child => {
    if (isValidElement<PropsWithChildren<FrameButtonProps>>(child)) {
      return cloneElement(child, {
        shouldFrameButton: true,
      })
    }
    return child
  })

  return <S.ButtonFrame>{childrenWithProps}</S.ButtonFrame>
}
